// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsReshootV1_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 2H22V10.2917C21.1344 9.51691 20.1179 8.90722 19 8.51212V8H18V8.22302C17.3568 8.07706 16.6874 8 16 8C15.8345 8 15.67 8.00447 15.5066 8.01329L15 7H18V6H19L18 4H16L17 6H13V8H15V8.05493C13.9326 8.17292 12.9215 8.47757 12 8.93552V8H11L12 5H13V4H11L10 6H9L9.66667 8H11L10 10H4V20H7.51212C7.76379 20.7121 8.10253 21.383 8.51555 22H2V2ZM7 4H4V7V8H8V6H7V7H4L5 5H7V4Z" class="svg-bg"/>
  <path d="M10.2547 13C11.5196 11.1865 13.6213 10 16 10 19.866 10 23 13.134 23 17H24L22 20 20 17H21C21 14.2386 18.7614 12 16 12 14.8742 12 13.8353 12.3721 12.9995 13H10.2547ZM16 24C18.3787 24 20.4804 22.8135 21.7453 21H19.0005C18.1647 21.6279 17.1258 22 16 22 13.2386 22 11 19.7614 11 17H12L10 14 8 17H9C9 20.866 12.134 24 16 24Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsReshootV1 is a generated icon component.
 */
let IconRmsReshootV1 = IconRmsReshootV1_1 = class IconRmsReshootV1 extends IconBaseElement {
    render() {
        return html `${IconRmsReshootV1_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsReshootV1.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsReshootV1 = IconRmsReshootV1_1 = __decorate([
    customElement('zui-icon-rms-reshoot-v-1')
], IconRmsReshootV1);
export { IconRmsReshootV1 };
